// main.tsx - Punto de entrada de la aplicación
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { TenantProvider } from './contexts/TenantContext';
import './index.css';
import { installFetchAuth } from './shared/utils/fetchAuth';
import { captureInstallPrompt } from './shared/utils/installPrompt';

// Las llamadas fetch() al servidor llevan sesión y empresa (ver fetchAuth.ts)
installFetchAuth();
// Guardar el aviso de "instalar app" del navegador para el botón Instalar (InstallAppBanner)
captureInstallPrompt();

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <TenantProvider>
                <App />
            </TenantProvider>
        </BrowserRouter>
    </React.StrictMode>
);
